import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Box } from 'reflexbox';
import Loader from 'components/Loader';
import Product from './components/Product';
import NoProducts from './components/NoProducts';
import EmergencyMessage from 'components/EmergencyMessage';

import './productList.styles.scss';

export default class ProductList extends Component {
    componentDidMount() {
        const { products, updateLoadingFlag } = this.props;

        if (Object.keys(products).length === 0) {
            updateLoadingFlag(true);
            this.getListProducts();
        }
    }

    /**
     * Don't update the component if product data changes, only if product list changes or a toast arrives
     * @param {object} nextProps
     */
    shouldComponentUpdate(nextProps) {
        const { isLoading, products, selectedList } = this.props;

        const differentProducts = Object.keys(products).length !== Object.keys(nextProps.products).length;
        const toasts = nextProps.toastr !== undefined;
        const differentList = selectedList !== nextProps.selectedList;

        return isLoading || differentProducts || toasts || differentList;
    }

    componentDidUpdate(prevProps) {
        const { selectedList } = this.props;

        if (selectedList !== prevProps.selectedList) {
            this.getListProducts();
        }
    }

    getListProducts() {
        const { selectedList, getListProducts, updateLoadingFlag } = this.props;

        if (!selectedList) {
            return;
        }
        updateLoadingFlag(true);
        getListProducts(selectedList);
    }

    render() {
        const { products, isLoading } = this.props;

        if (isLoading) {
            return (
                <Loader theme="animation" />
            );
        }
        // List is empty
        if (Object.keys(products).length === 0) return <NoProducts />;

        // Iterate through products and generate a Product component for each one
        const productComponents = [];
        let fallbackSort = 0;
        for (const article in products) {
            productComponents[products[article].sortId || fallbackSort++] = (<Product
                key={article}
                productId={products[article].articleNumber}
            />);
        }

        return (
            <Box className="productlist">
                <EmergencyMessage />
                {productComponents}
            </Box>
        );
    }
}

ProductList.propTypes = {
    products: PropTypes.object.isRequired,
    selectedList: PropTypes.any,
    isLoading: PropTypes.bool,
    getListProducts: PropTypes.func.isRequired,
    updateLoadingFlag: PropTypes.func.isRequired,
    toastr: PropTypes.any,
};
